// Opaque lead id — recognize a lead who gave us an email when they come back (Oct 2026).
//
// The id is an HMAC of their email computed by the server (not the email itself). It is stored
// in first-party localStorage ONLY after they give us an email (or click through from one of our
// emails), and NEVER if they chose "Decline" on the cookie banner. Page-view / event beacons send
// it so the admin Leads view can show "visited / clicked / opened" per lead. Disclosed in the
// privacy policy (Cookies section).
const LID_KEY = 'rigacap_lid';
const CONSENT_KEY = 'rigacap_cookie_consent';
const LID_RE = /^[a-f0-9]{24}$/;

const declined = () => {
  try { return localStorage.getItem(CONSENT_KEY) === 'declined'; } catch { return true; }
};

export function getLeadId() {
  if (declined()) return null;
  try { const v = localStorage.getItem(LID_KEY); return v && LID_RE.test(v) ? v : null; } catch { return null; }
}

export function setLeadId(id) {
  if (!id || !LID_RE.test(id) || declined()) return;
  try { localStorage.setItem(LID_KEY, id); } catch { /* ignore */ }
}

export function clearLeadId() {
  try { localStorage.removeItem(LID_KEY); } catch { /* ignore */ }
}

// Click-through from our email carries ?rlid=<id> (added by the API's click redirect). Store it
// (consent permitting) and strip it from the address bar so it isn't shared or bookmarked.
export function captureLeadFromUrl() {
  try {
    const url = new URL(window.location.href);
    const rlid = url.searchParams.get('rlid');
    if (!rlid) return;
    setLeadId(rlid.toLowerCase());
    url.searchParams.delete('rlid');
    window.history.replaceState(window.history.state, '', url.pathname + (url.search || '') + url.hash);
  } catch { /* ignore */ }
}
